import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from 'moment'

// 导入设置rem。js
import "amfe-flexible";

// 导入mock
// import "./mock/index";
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// 导入全局样式
import "@/assets/style/global.less";

// Vant
// import Vant from "vant";
// import "vant/lib/index.css";
// Vue.use(Vant);
import { Swipe, SwipeItem,Button,Icon,Tab,Tabs,Pagination,Loading,Empty,Collapse,CollapseItem,Field ,Form,Toast,Step,Steps,Popup, Search,Lazyload,ActionSheet } from 'vant'
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Popup)
Vue.use(Search)
Vue.use(Lazyload)
Vue.use(ActionSheet )
Vue.use(mavonEditor)

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.prototype.$moment = moment

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
